import type { IconNode } from '../types';

/**
 * @name elephant
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTQuNSAxMkgxNGMtMi44IDAtNS0yLjItNS01VjVhMiAyIDAgMCAxIDItMmgyYzEuNSAwIDIuOC44IDMuNCAySDE5YzEuNyAwIDMgMS4zIDMgM3YxMCIgLz4KICA8cGF0aCBkPSJNMTggMTBoLjAxIiAvPgogIDxwYXRoIGQ9Ik0xNCAxMGE0IDQgMCAwIDAgNCA0IDQgNCAwIDAgMSA0IDQgMiAyIDAgMCAxLTQgMCIgLz4KICA8cGF0aCBkPSJNMTAgMTZ2NSIgLz4KICA8cGF0aCBkPSJNMTggMTRhNCA0IDAgMCAwLTQgNHYzSDZ2LTIuNmMwLTEuMS0uOC0yLjMtMS43LTNDMi45IDE0LjMgMiAxMi44IDIgMTFjMC0zLjMgMy4xLTYgNy02IiAvPgogIDxwYXRoIGQ9Ik0yIDExdjciIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/elephant
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const elephant: IconNode = [
  [
    'path',
    {
      d: 'M14.5 12H14c-2.8 0-5-2.2-5-5V5a2 2 0 0 1 2-2h2c1.5 0 2.8.8 3.4 2H19c1.7 0 3 1.3 3 3v10',
      key: '4x5b8h',
    },
  ],
  ['path', { d: 'M18 10h.01', key: 'fcfu2g' }],
  ['path', { d: 'M14 10a4 4 0 0 0 4 4 4 4 0 0 1 4 4 2 2 0 0 1-4 0', key: '1go82k' }],
  ['path', { d: 'M10 16v5', key: '1m01c3' }],
  [
    'path',
    {
      d: 'M18 14a4 4 0 0 0-4 4v3H6v-2.6c0-1.1-.8-2.3-1.7-3C2.9 14.3 2 12.8 2 11c0-3.3 3.1-6 7-6',
      key: '1n1tte',
    },
  ],
  ['path', { d: 'M2 11v7', key: '15dahq' }],
];

export default elephant;
